<template>
  <div>
    <data-table :service="TranslationService"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                operations="delete,add,refresh"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                :show-pagination="false"
                :show-confirm-before-delete="false"
                :clickable="false"
                @on-add="addRow"
                ref="table">
      <template slot="table-header-left">
        <language-select :value="selectedLocale" @change="changeLanguage">
        </language-select>
      </template>
      <template slot="extra-buttons" slot-scope="{row, index}">
        <base-button class="mr-2"
                     outline
                     @click.stop="addRow(row, index)" type="info" icon size="sm">
          <i class="fas fa-clone"></i>
        </base-button>
      </template>
      <template slot="group" slot-scope="{row, index}">
        <editable-grid-cell :value="row.group"
                            :show-input="!row.id"
                            :editable="!row.id"
                            placeholder="Group"
                            @keyup.enter="trySave(row, index)"
                            @change="(val) => updateTranslation(val, 'group', row, index)">
          {{row.group}}
        </editable-grid-cell>
      </template>
      <b slot="item" slot-scope="{row, index}">
        <editable-grid-cell :value="row.item"
                            placeholder="Item"
                            :show-input="!row.id"
                            :editable="!row.id"
                            @keyup.enter="trySave(row, index)"
                            @change="(val) => updateTranslation(val, 'item', row, index)">
          {{row.item}}
        </editable-grid-cell>
      </b>
      <div class="d-flex align-items-center" slot="text" slot-scope="{row, index}">
        <editable-grid-cell :value="row.text"
                            :show-input="!row.id"
                            placeholder="Text"
                            @keyup.enter="trySave(row, index)"
                            @change="(val) => updateTranslation(val, 'text', row, index)">
          {{row.text}}
        </editable-grid-cell>
        <base-button v-if="!row.id"
                     class="ml-2"
                     outline
                     @click.stop="saveTranslation(row, index)" type="success" icon>
          <i class="nc-icon nc-check-2"></i>
        </base-button>
      </div>
    </data-table>
  </div>
</template>
<script>
  import LanguageSelect from "src/components/LanguageSelect";
  import TranslationService from 'src/services/TranslationService';
  import EditableGridCell from 'src/components/EditableGridCell';
  import entities from 'src/config/entities';

  export default {
    components: {
      EditableGridCell,
      LanguageSelect
    },
    data() {
      return {
        TranslationService,
        entity: entities.TRANSLATION,
        saving: false,
        selectedLocale: this.$i18n.locale,
      }
    },
    computed: {
      columns() {
        return [
          {
            prop: "group",
            label: 'Group',
            minWidth: "80px",
          },
          {
            prop: "item",
            label: 'Item',
            minWidth: "140px"
          },
          {
            prop: "text",
            label: 'Translation',
            minWidth: "200px"
          }
        ]
      },
      filters() {
        return [{ key: 'locale', value: this.selectedLocale }]
      }
    },
    methods: {
      async changeLanguage(lang) {
        this.selectedLocale = lang;
      },
      async updateTranslation(evt, key, row, index = 0) {
        let value = evt.target.value;
        this.saving = true;
        let id = row.id;
        if (id) {
          let data = {
            ...row,
            [key]: value
          };
          await TranslationService.update(id, data);
          row[key] = value;
        } else {
          row[key] = value;
        }
        this.saving = false;
      },
      async trySave(row, index) {
        if(!row.id) {
          await this.saveCountry(row, index)
        }
      },
      async saveCountry(row, index = 0) {
        let result = await TranslationService.create(row);
        this.$refs.table.tableData.splice(index, 1, result.data);
      },
      async addRow(rowData = {}, index = 0) {
        let row = {
          locale: this.selectedLocale,
          group: '',
          item: '',
          text: '',
          ...rowData
        };
        delete row.id;
        this.$refs.table.tableData.splice(index, 0, row);
      }
    }
  }
</script>
<style>
</style>
